import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const QuotationInvoiceTemplate = ({
  headerBase64,
  footerBase64,
  dgSignBase64,
  watermarkBase64,
  quotation,
  enquiry,
  quotationData,
  invoice_date,
  grandTotal,
  numberToWords,
  selectedValue,
  type,
  bankAc,
  invoice_no,
  tax_type,
  tax_id,
  quoteTitle
}) => {
  console.log('quotationData++', quotationData);
  const supply_add = quotation?.supply_add || "";
  const valid_date = quotation?.vaild_date || "";

  const doc = new jsPDF('p', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 6;
  const headerHeight = 28;
  const footerHeight = footerBase64 ? 25 : 8;
  const contentTop = headerHeight + 2;
  let isFirstPage = true;

  const colors = {
    primary: [220, 220, 220],
    secondary: [0,0,0],
    accent: [180, 180, 180],
    lightGray: [250, 250, 250],
    mediumGray: [240, 240, 240],
    border: [210, 210, 210],
    highlight: [245, 245, 245],
    textDark: [0, 0, 0]
  };

  const addHeader = () => {
    if (headerBase64) doc.addImage(headerBase64, 'PNG', 0, 0, pageWidth, headerHeight);
  };

  const addWatermark = () => {
    if (!watermarkBase64) return;
    const wmWidth = pageWidth / 2;
    const wmHeight = wmWidth;
    const wmX = (pageWidth - wmWidth) / 2;
    const wmY = (pageHeight - wmHeight) / 2;
    doc.setGState(new doc.GState({ opacity: 0.05 }));
    doc.addImage(watermarkBase64, 'PNG', wmX, wmY, wmWidth, wmHeight);
    doc.setGState(new doc.GState({ opacity: 1 }));
  };

  const addPageFooter = () => {
    doc.setFontSize(8);
    doc.setTextColor(...colors.secondary);
    doc.text(
      `Page ${doc.internal.getCurrentPageInfo().pageNumber}`,
      pageWidth - margin,
      pageHeight - 5,
      { align: 'right' }
    );
    if (footerBase64) {
      doc.addImage(footerBase64, 'PNG', 0, pageHeight - footerHeight, pageWidth, footerHeight);
    }
  };

  const drawTopSection = (startY = contentTop) => {
    let y = startY;

    // Document title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...colors.textDark);
    doc.text(type, pageWidth / 2, y + 5, { align: 'center' });
    y += 6;

    // Date and number section
    doc.setFillColor(...colors.lightGray);
    doc.rect(margin, y, pageWidth - 2 * margin, 8, 'F');
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...colors.secondary);
    const formattedDate = invoice_date
      ? new Date(invoice_date).toLocaleDateString("en-GB")
      : new Date().toLocaleDateString("en-GB");
    doc.text(`Date: ${formattedDate}`, margin + 3, y + 5.5);
    const invoiceNum = type === 'INVOICE' ? invoice_no || '-' : quotation.qu_no || '-';
    doc.text(`${type} No: ${invoiceNum}`, pageWidth - margin - 3, y + 5.5, { align: 'right' });
    y += 8;

    // Customer Details section with Shipping Address side by side
    const leftBoxWidth = (pageWidth - 2 * margin - 5) / 2;
    const rightBoxWidth = leftBoxWidth;
    const leftBoxX = margin;
    const rightBoxX = leftBoxX + leftBoxWidth + 5;

    const cardStartY = y;

    // Determine GSTIN value; skip row if not found
    const gstinValue = tax_id || enquiry.tax_id || "";
    const showGstin = gstinValue && gstinValue.trim().length > 0;

    let leftContentLines = 0;
    let rightContentLines = 0;

    leftContentLines = 1; // Valid Till line
    if (supply_add && supply_add.trim()) {
      const shippingLines = doc.splitTextToSize(supply_add, leftBoxWidth - 10);
      leftContentLines += 1 + shippingLines.length;
    }

    const addrValue = enquiry.address || "-";
    const addrLines = doc.splitTextToSize(addrValue, rightBoxWidth - 10 - doc.getTextWidth("Address: "));
    rightContentLines = 1 + 1 + addrLines.length + 1 + (showGstin ? 1 : 0);

    const maxLines = Math.max(leftContentLines, rightContentLines);
    const cardHeight = 5 + (maxLines * 4.5);

    // Left Card
    doc.setFillColor(...colors.lightGray);
    doc.setDrawColor(...colors.lightGray);
    doc.setLineWidth(0.1);
    doc.roundedRect(leftBoxX, cardStartY, leftBoxWidth, cardHeight, 2, 2, 'FD');

    let leftY = cardStartY + 5;

    if (valid_date) {
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...colors.secondary);
      const validTillDate = new Date(valid_date).toLocaleDateString("en-GB");
      doc.text(`Valid Till: ${validTillDate}`, leftBoxX + 5, leftY);
      leftY += 4.5;
    }

    if (supply_add && supply_add.trim()) {
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...colors.secondary);
      doc.text('Shipping Address:', leftBoxX + 5, leftY);
      leftY += 4.5;

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(...colors.secondary);

      const shippingLines = doc.splitTextToSize(supply_add, leftBoxWidth - 10);
      shippingLines.forEach((line) => {
        doc.text(line, leftBoxX + 5, leftY);
        leftY += 4.5;
      });
    }

    // Right Card
    doc.setFillColor(...colors.lightGray);
    doc.setDrawColor(...colors.lightGray);
    doc.setLineWidth(0.1);
    doc.roundedRect(rightBoxX, cardStartY, rightBoxWidth, cardHeight, 2, 2, 'FD');

    let rightY = cardStartY + 5;

    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...colors.secondary);
    doc.text('Customer Details:', rightBoxX + 5, rightY);
    rightY += 4.5;

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...colors.secondary);
    doc.text(enquiry.name || "-", rightBoxX + 5, rightY);
    rightY += 4.5;

    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...colors.secondary);

    let label = "Address: ";
    doc.setFont("helvetica", "bold");
    const addrLabelWidth = doc.getTextWidth(label);
    doc.text(label, rightBoxX + 5, rightY);
    doc.setFont("helvetica", "normal");
    addrLines.forEach((l, idx) => {
      if (idx === 0) {
        doc.text(l, rightBoxX + 5 + addrLabelWidth, rightY);
      } else {
        rightY += 4.5;
        doc.text(l, rightBoxX + 5 + addrLabelWidth, rightY);
      }
    });
    rightY += 4.5;

    label = "Contact: ";
    doc.setFont("helvetica", "bold");
    doc.text(label, rightBoxX + 5, rightY);
    doc.setFont("helvetica", "normal");
    doc.text(enquiry.mobile_no || "-", rightBoxX + 5 + doc.getTextWidth(label), rightY);
    rightY += 4.5;

    if (showGstin) {
      label = "GSTIN: ";
      doc.setFont("helvetica", "bold");
      doc.text(label, rightBoxX + 5, rightY);
      doc.setFont("helvetica", "normal");
      doc.text(gstinValue, rightBoxX + 5 + doc.getTextWidth(label), rightY);
    }

    y = cardStartY + cardHeight + 1;
    return y;
  };

  // First page setup
  addHeader();
  addWatermark();
  let tableStartY = drawTopSection();

  /* -------------------- TAX CALCULATION -------------------- */
 let subTotal = 0;
let totalTaxAmount = 0;
quotationData.forEach(item => {
  const qty = item.qty || 0;
  const unitPrice = parseFloat(item.unitprice) || 0;
  const taxPercent = item.tax || 0;
  const rowTotal = qty * unitPrice;
  const rowTax = rowTotal * (taxPercent / 100);
  subTotal += rowTotal;
  totalTaxAmount += rowTax;
});

  let sgstAmount = 0;
  let cgstAmount = 0;
  let igstAmount = 0;
  if ((tax_type || "").toUpperCase() === "IGST") {
    igstAmount = totalTaxAmount;
  } else {
    sgstAmount = totalTaxAmount / 2;
    cgstAmount = totalTaxAmount / 2;
  }

  // const finalTotal = subTotal + totalTaxAmount;
  const finalTotal = typeof grandTotal === 'number' && grandTotal > 0
  ? grandTotal
  : subTotal + totalTaxAmount;

  /* -------------------- TABLE -------------------- */
  const tableRows = quotationData.map((item, idx) => {
    const qty = parseFloat(item.qty) || 0;
    const unitPrice = parseFloat(item.unitprice) || 0;
    const taxPercent = parseFloat(item.tax) || 0;
    const rowTotal = qty * unitPrice;
    return [
      idx + 1,
      item.description || "-",
      item.sku || "-",
      qty.toFixed(0),
      item.unit || "-",
      unitPrice.toLocaleString("en-IN", { minimumFractionDigits: 2 }),
      Number.isInteger(taxPercent) ? taxPercent.toString() : taxPercent.toString(),
      rowTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })
    ];
  });

  autoTable(doc, {
    startY: tableStartY,
    head: [[
      "SI NO",
      "DESCRIPTION",
      "HSN/SAC CODE",
      "QTY",
      "UNIT",
      "UNIT PRICE",
      "TAX (%)",
      "TOTAL"
    ]],
    body: tableRows,
    margin: {
      left: margin,
      right: margin,
      top: headerHeight + 1,
      bottom: footerHeight + 10
    },
    theme: 'striped',
    headStyles: {
      fillColor: colors.primary,
      textColor: colors.textDark,
      fontStyle: 'bold',
      halign: 'center',
      fontSize: 8.5
    },
    bodyStyles: {
      fontSize: 8.5,
      textColor: colors.secondary
    },
    columnStyles: {
      0: { halign: 'center', cellWidth: 10 },
      1: { halign: 'left', cellWidth: 'auto' },
      2: { halign: 'center', cellWidth: 22 },
      3: { halign: 'center', cellWidth: 12 },
      4: { halign: 'center', cellWidth: 14 },
      5: { halign: 'right', cellWidth: 22 },
      6: { halign: 'center', cellWidth: 12 },
      7: { halign: 'right', cellWidth: 24 }
    },
    didDrawPage: (data) => {
      addWatermark();
      addPageFooter();
      if (!isFirstPage) addHeader();
      if (isFirstPage) isFirstPage = false;
    }
  });

  /* -------------------- SUMMARY BOX WITH BANK DETAILS SIDE BY SIDE -------------------- */
  let currentY = doc.lastAutoTable.finalY + 0.2;
  const summaryWidth = 80;
  const summaryX = pageWidth - margin - summaryWidth;

  const summaryRows = [
    ["Sub Total", parseFloat(subTotal.toFixed(2))],
  ];
  if (igstAmount > 0) {
    summaryRows.push(["IGST", parseFloat(igstAmount.toFixed(2))]);
  } else {
    summaryRows.push(["SGST", parseFloat(sgstAmount.toFixed(2))]);
    summaryRows.push(["CGST", parseFloat(cgstAmount.toFixed(2))]);
  }
  summaryRows.push(["Total", parseFloat(finalTotal.toFixed(2))]);

  summaryRows.forEach((row, i) => {
    const y = currentY + i * 6.3;
    if (row[0] === "Total") {
      doc.setFillColor(...colors.mediumGray);
      doc.setTextColor(...colors.textDark);
      doc.setFont("helvetica", "bold");
    } else {
      doc.setFillColor(...colors.lightGray);
      doc.setTextColor(...colors.secondary);
      doc.setFont("helvetica", "normal");
    }
    doc.rect(summaryX, y, summaryWidth, 8, "F");
    doc.text(row[0], summaryX + 4, y + 5.5);
    doc.text(
      Number(row[1]).toLocaleString("en-IN", { minimumFractionDigits: 2 }),
      summaryX + summaryWidth - 4,
      y + 5.5,
      { align: "right" }
    );
  });

  // Bank Details Section
  if (bankAc) {
    const bankWidth = summaryX - margin - 5;
    const bankX = margin;
    let bankY = currentY;
    const lineHeight = 5.3;

    doc.setFillColor(...colors.mediumGray);
    doc.rect(bankX, bankY, bankWidth, 6, 'F');
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...colors.secondary);
    doc.text('BANK DETAILS', bankX + 2, bankY + 4.5);
    bankY += 10;

    doc.setFontSize(8.5);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...colors.secondary);

    const bankLines = [
      `Account Holder: ${bankAc.holder_name || ''}`,
      `Bank: ${bankAc.bank_name || ''}`,
      `Account No: ${bankAc.ac_no || ''}`,
      `IFSC: ${bankAc.ifsc_code || ''}`,
      `${(bankAc.bank_address || '').replace(/\n/g, ' ')}`
    ];

    bankLines.forEach(line => {
      const wrapped = doc.splitTextToSize(line, bankWidth - 4);
      wrapped.forEach(part => {
        doc.text(part, bankX + 2, bankY);
        bankY += lineHeight;
      });
    });
  }

  currentY += summaryRows.length * 6.7 + 0;

  /* -------------------- GRAND TOTAL IN WORDS -------------------- */
  // Label and amount in words on the same line; overflow wraps only the text portion
  const formattedTotal = parseFloat((finalTotal).toFixed(2));
  const rupees = Math.floor(formattedTotal);
  const paise = Math.round((formattedTotal - rupees) * 100);

  const taxFromGrandTotal = finalTotal - subTotal; // tax portion from the UI's grand total



  let words = numberToWords(rupees);
  if (paise > 0) {
    words += ` and ${numberToWords(paise)} Paise`;
  }
  words += " Only";

  const wordsLabel = "Grand Total (In Words): ";
  const wordsBoxWidth = pageWidth - 2 * margin;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  const labelWidth = doc.getTextWidth(wordsLabel);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8.5);
  const wordsAvailWidth = wordsBoxWidth - 6 - labelWidth;
  const wrappedWords = doc.splitTextToSize(words, wordsAvailWidth);

  const wordsLineH = 5;
  const wordsBoxHeight = 4 + (wrappedWords.length * wordsLineH);

  if (currentY + wordsBoxHeight > pageHeight - footerHeight - 5) {
    addPageFooter();
    doc.addPage();
    addHeader();
    addWatermark();
    currentY = headerHeight + 15;
  }

  const actualWordsBoxY = currentY;

  doc.setFillColor(...colors.highlight);
  doc.setDrawColor(...colors.border);
  doc.setLineWidth(0.3);
  doc.roundedRect(margin, actualWordsBoxY, wordsBoxWidth, wordsBoxHeight, 2, 3, 'FD');

  const textBaseY = actualWordsBoxY + 5;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(...colors.secondary);
  doc.text(wordsLabel, margin + 3, textBaseY);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8.5);
  wrappedWords.forEach((line, idx) => {
    if (idx === 0) {
      doc.text(line, margin + 3 + labelWidth, textBaseY);
    } else {
      doc.text(line, margin + 3 + labelWidth, textBaseY + idx * wordsLineH);
    }
  });

  currentY = actualWordsBoxY + wordsBoxHeight + 5;

  // Decode HTML entities (e.g. &amp; → &, &nbsp; → space, &lt; → <, etc.)
  const decodeHtmlEntities = (str) => {
    return str
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/gi, "'")
      .replace(/&apos;/gi, "'")
      .replace(/&ndash;/gi, "–")
      .replace(/&mdash;/gi, "—")
      .replace(/&laquo;/gi, "«")
      .replace(/&raquo;/gi, "»")
      .replace(/&copy;/gi, "©")
      .replace(/&reg;/gi, "®")
      .replace(/&trade;/gi, "™")
      .replace(/&hellip;/gi, "…")
      .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec))
      .replace(/&#x([0-9a-f]+);/gi, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
  };

  // Parse terms and conditions
  let finalTerms = [];
  if (selectedValue?.data) {
    const html = selectedValue.data;
    const withLineBreaks = html
      .replace(/<li[^>]*>/gi, "\n")
      .replace(/<\/li>/gi, "")
      .replace(/<p[^>]*>/gi, "\n")
      .replace(/<div[^>]*>/gi, "\n")
      .replace(/<\/p>/gi, "")
      .replace(/<\/?[^>]+(>|$)/g, "")
      .trim();
    finalTerms = withLineBreaks
      .split("\n")
      .map(line => decodeHtmlEntities(line).trim())
      .filter(line => line.length > 0);
  }

  /* -------------------- TERMS & CONDITIONS -------------------- */
  const termsLineHeight = 4.8;
  const termsWidth = pageWidth - 2 * margin;
  const leftX = margin;

  const sigWidth = pageWidth * 0.15;
  const sigHeight = sigWidth * 0.9;
  const signatureSpaceNeeded = dgSignBase64 ? sigHeight + 8 : 10;

  if (finalTerms.length > 0) {
    let termsY = currentY;

    if (termsY + 16 > pageHeight - footerHeight - 5) {
      addPageFooter();
      doc.addPage();
      addHeader();
      addWatermark();
      termsY = headerHeight + 15;
    }

    doc.setFillColor(...colors.mediumGray);
    doc.rect(leftX, termsY, termsWidth, 6, 'F');
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...colors.secondary);
    doc.text('TERMS & CONDITIONS', leftX + 2, termsY + 4.5);
    termsY += 8;

    doc.setFontSize(8.5);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...colors.secondary);

    finalTerms.forEach((line) => {
      const wrapped = doc.splitTextToSize(line, termsWidth - 6);

      wrapped.forEach((wrappedLine, wIndex) => {
        if (termsY + termsLineHeight > pageHeight - footerHeight - 5) {
          addPageFooter();
          doc.addPage();
          addHeader();
          addWatermark();
          termsY = headerHeight + 15;
        }

        const bullet = wIndex === 0 ? '• ' : '  ';
        doc.text(`${bullet}${wrappedLine}`, leftX + 3, termsY);
        termsY += termsLineHeight;
      });
    });

    currentY = termsY + 1;
  }

  /* -------------------- SIGNATURE SECTION -------------------- */
  const availableSpace = pageHeight - footerHeight - currentY - 3;

  if (availableSpace < signatureSpaceNeeded) {
    addPageFooter();
    doc.addPage();
    addHeader();
    addWatermark();
    currentY = headerHeight + 15;
  }

  const sigX = pageWidth - sigWidth - margin;
  const sigY = currentY;

  if (dgSignBase64) {
    doc.addImage(dgSignBase64, "PNG", sigX, sigY, sigWidth, sigHeight);
    doc.setFontSize(7.5);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...colors.secondary);
    doc.text("Authorized Signatory", sigX, sigY + sigHeight + 2.5);
  } else {
    doc.setFontSize(8.5);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...colors.secondary);
    doc.text("Authorized Signatory", sigX, sigY);
  }

  addPageFooter();
  return doc;
};

export default QuotationInvoiceTemplate;